export { default as pluralize } from "./src/utils/pluralizer";
export { default as objectCamelCased } from "./src/utils/objectCamelCased";
export { default as getDate } from "./src/utils/getDate";
export { default as getLetterAvatar } from "./src/utils/letterAvatar";
export { default as ObjectUtils } from "./src/utils/Object";

export default {};
